// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, maybe, enumOf, recordOf, anyOf } from "@altostra/type-validations";
import { boolean, number, string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isGetAppGroupsAppGroupIdBannerPriorityResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      name: string,
      id: string,
      priority_bucket: anyOf(nullOrUndefined, number),
      priority: anyOf(nullOrUndefined, number),
      is_draft: boolean,
      type: enumOf("campaign", "canvas_step"),
      is_pinned: maybe(boolean),
    })
  ),
});

export const isPostAppGroupsAppGroupIdBannerPriorityResult = objectOf({
  priority_bucket: maybe(number),
  priority: maybe(number),
  is_visible_in_list: maybe(boolean),
  priorities_by_item_id: maybe(
    recordOf({
      key: string,
      value: objectOf({
        priority_bucket: number,
        priority: number,
        is_visible_in_list: boolean,
      }),
    })
  ),
});
